import { useState, useEffect } from "react";
import { useAuth } from "@api/useAuth";
import { useTransfers } from "@api/hooks";
import { isOrganizerOrAdmin } from "@utils";
import AlertModal from "./AlertModal";

/**
 * Notifies Organizer/Admin on login that intercompany transfers are awaiting
 * approval. Mirrors PendingHandoffAlert: fetch a single row with
 * `?status=pending&limit=1` and read the paginated `count` for the total.
 */
export default function PendingTransferAlert() {
  const { user, isLoading: authLoading } = useAuth();
  // Only Organizer/Admin approve transfers, so only they get the nudge.
  const isEligible = !authLoading && !!user && isOrganizerOrAdmin(user);
  const [open, setOpen] = useState(false);

  const { data } = useTransfers({ status: "pending", limit: 1 }, { enabled: isEligible });

  useEffect(() => {
    if (data?.count > 0) setOpen(true);
  }, [data?.count]);

  if (!isEligible || !open) return null;

  const count = data?.count ?? 0;

  return (
    <AlertModal isOpen={open} onClose={() => setOpen(false)} title="Pending Transfers">
      <p className="text-smiles-darkGray">
        There {count !== 1 ? "are" : "is"}{" "}
        <span className="font-semibold text-palette-yellow-secondary">{count}</span> intercompany
        transfer{count !== 1 ? "s" : ""} awaiting approval. Please visit{" "}
        <span className="font-medium">Cash Flow → Actions</span> to review{" "}
        {count !== 1 ? "them" : "it"}.
      </p>
    </AlertModal>
  );
}
